// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Emideltide (DSIP) 09.17.26" (31f4ad82-d471-4129-87a8-d6d907c46e67). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiEmideltideDSIPAnswerField } from './questions';

export const mdiEmideltideDSIP: FormType<mdiEmideltideDSIPAnswerField> = {
  name: 'Emideltide (DSIP)',
  validityLength: 25,
  questions: [
    {
      key: 'mdiEmideltideDSIP_sex',
      next: {
        switch: [
          {
            condition: { 'mdiEmideltideDSIP_sex.female': true },
            key: 'mdiEmideltideDSIP_pregnancy'
          },
          {
            condition: { 'mdiEmideltideDSIP_pregnancy.yes': true },
            key: 'mdiEmideltideDSIP_wereSorryTreatmentNotMedically'
          }
        ],
        els: 'mdiEmideltideDSIP_importantClickAttachedLinkReview'
      }
    },
    {
      key: 'mdiEmideltideDSIP_pregnancy',
      next: {
        condition: { 'mdiEmideltideDSIP_pregnancy.yes': true },
        key: 'mdiEmideltideDSIP_wereSorryTreatmentNotMedically',
        els: 'mdiEmideltideDSIP_importantClickAttachedLinkReview'
      }
    },
    'mdiEmideltideDSIP_wereSorryTreatmentNotMedically',
    'mdiEmideltideDSIP_importantClickAttachedLinkReview',
    'mdiEmideltideDSIP_reasonInterestedPeptide',
    {
      key: 'mdiEmideltideDSIP_everUsedPeptideTherapiesPast',
      next: {
        condition: {
          'mdiEmideltideDSIP_everUsedPeptideTherapiesPast.yes': true
        },
        key: 'mdiEmideltideDSIP_peptidesUsedPreviously',
        els: 'mdiEmideltideDSIP_everReactionSideEffectsPeptide'
      }
    },
    'mdiEmideltideDSIP_peptidesUsedPreviously',
    {
      key: 'mdiEmideltideDSIP_everReactionSideEffectsPeptide',
      next: {
        condition: {
          'mdiEmideltideDSIP_everReactionSideEffectsPeptide.yes': true
        },
        key: 'mdiEmideltideDSIP_reactionSideEffect',
        els: 'mdiEmideltideDSIP_diagnosedRedFlagMedicalConditions'
      }
    },
    'mdiEmideltideDSIP_reactionSideEffect',
    'mdiEmideltideDSIP_diagnosedRedFlagMedicalConditions',
    'mdiEmideltideDSIP_confirmNotHistoryCancerKidney',
    {
      key: 'mdiEmideltideDSIP_takeRedFlagMedicationsSubstances',
      next: {
        condition: {
          'mdiEmideltideDSIP_takeRedFlagMedicationsSubstances.heavy_alcohol_use':
            true
        },
        key: 'mdiEmideltideDSIP_manyAlcoholicDrinksConsumeOne',
        els: 'mdiEmideltideDSIP_allergyBenzylPeroxide'
      }
    },
    'mdiEmideltideDSIP_manyAlcoholicDrinksConsumeOne',
    'mdiEmideltideDSIP_allergyBenzylPeroxide',
    'mdiEmideltideDSIP_lastTimePersonMedicalEvaluation',
    'mdiEmideltideDSIP_confirmUnderstandContactDoctorQuestions',
    'mdiEmideltideDSIP_firstMessageDoctor',
    'mdiEmideltideDSIP_complete'
  ]
};
